/**
 * The header's notice when the country has no recipient timezone: what it
 * blocks, in plain words, and the button that opens the times dialog on it.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Globe } from 'lucide-react';

export const TimezoneNotice: FC<{ onSet: () => void }> = ({ onSet }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-destructive/30 bg-destructive/5 px-3 py-2 text-xs text-destructive">
    <Globe className="h-4 w-4 shrink-0" />
    <span className="min-w-0 flex-1">
      This country&apos;s timezone is not set. Until it is, no time can be placed: no Danish times, no hour chart, no day plan — and the plan cannot be enabled.
    </span>
    <button type="button" onClick={onSet} className="rounded-md border border-destructive/40 bg-background px-2.5 py-1 font-medium text-destructive transition-colors hover:bg-destructive/10">
      Set the timezone
    </button>
  </div>
);
